import script from "./Certificate.vue?vue&type=script&setup=true&lang=ts"
export * from "./Certificate.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__